<template>
  <section
    v-if="text || (viewer?.is_owner && ownerViewMode)"
    id="about"
    class="py-20 bg-[var(--rms-t5-primary,#2563eb)]/5"
    aria-labelledby="about-heading-t5"
  >
    <div class="max-w-4xl mx-auto px-6 text-center">
      <h2 id="about-heading-t5" class="rms-t5-heading">
        {{ $t('public.about') }}
      </h2>
      <p v-if="text" class="text-xl lg:text-2xl font-medium leading-relaxed text-slate-800 dark:text-slate-200 whitespace-pre-line">
        {{ text }}
      </p>
      <div v-else-if="viewer?.is_owner && ownerViewMode" class="py-4 px-4 rounded border border-dashed border-slate-300/60 dark:border-slate-600/60 bg-slate-200/50 dark:bg-slate-700/20 max-w-md mx-auto">
        <p class="text-sm font-mono text-slate-600 dark:text-slate-400">{{ $t('public.noDescriptionSetOwnerMessage') }}</p>
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  text: { type: String, default: '' },
  viewer: { type: Object, default: () => ({ is_owner: false }) },
  ownerViewMode: { type: Boolean, default: true },
})
</script>

